import { Button, Empty, Flex, Typography } from 'antd';
import { push } from 'connected-react-router';
import debounce from 'lodash.debounce';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getLast10Applications } from '../../../../../../Store/ApplicationsReducer/applicationsActions';
import { taskColorByUUID } from '../../../../../constants/task-status';

export const Last10Applications = (props) => {
    const dispatch = useDispatch();
    const data = useSelector(state => state.applications.last10Applications);
    const tasks = data || []// Array.from({ length: 100 }, (_, i) => ({ subject: '123', status_uuid: TaskStatus.PLANNED }))

    const handleDebouncedEffect = async () => {
        dispatch(getLast10Applications(props.id));
    };

    const redirectToTask = (task) => {
        props?.onOpenHistoryApp && props.onOpenHistoryApp();
        dispatch(push(`/application/${task.employee_device_id}/${task.hash}`))
    }

    useEffect(() => {
        const debouncedEffect = debounce(() => {
            handleDebouncedEffect();
        }, 500);
        debouncedEffect();
        return () => {
            debouncedEffect.cancel();
        };
    }, []);

    return (
        <Flex vertical style={{
            padding: 8, overflowY: 'hidden', overflowX: 'hidden', height: '100%',
            opacity: props.open ? 1 : 0,
            transition: 'all 0.15s ease-in-out',
        }}>
            {props.hideTitle ? null : <Typography.Text type='secondary' style={{ marginLeft: 8 }}>История заявок</Typography.Text>}
            <Flex vertical gap={2} style={{
                overflowY: 'auto',
                overflowX: 'hidden',
                height: '100%',
            }}>
                {tasks.length === 0 ? (
                    <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description="Нет заявок"
                        style={{ marginTop: 16, marginBottom: 16 }}
                    />
                ) : (
                    <>
                        {tasks.map((task, index) => (
                            <Button
                                type='text'
                                size='large'
                                style={{ justifyContent: 'start', width: '100%', padding: '4px 8px' }}
                                onClick={() => redirectToTask(task)}
                                icon={
                                    <div style={{ height: 24, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <div style={{
                                            borderRadius: '50%',
                                            width: 12,
                                            height: 12,
                                            aspectRatio: '1',
                                            backgroundColor: taskColorByUUID(task.status_uuid)
                                        }} />
                                    </div>
                                }
                            >
                                <span style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}>{task.subject}</span>
                            </Button>
                        ))}
                    </>
                )}
            </Flex>
            {!!tasks.length && (
                <Button type='text' size='small' style={{ justifyContent: 'start', color: '#C0C0C0' }} onClick={() => dispatch(push(`/login/${props.id}`))}>
                    <span style={{
                        textDecoration: 'underline',
                    }}>
                        Посмотреть все
                    </span>
                </Button>
            )}
        </Flex>
    )
}